// undefined until resolved, because the resolved origin may itself be null.
let bundleApiHost;

/**
 * Returns `{ apiHost }`, where `apiHost` is the origin the bundle was served
 * from, so API calls target the bundle's origin rather than the host page's.
 * `apiHost` is null where the bundle has no usable origin, and callers then
 * resolve their path against the document.
 * A `window.sparkleApiHost` host-page override wins whenever this runs. The
 * bundle origin fallback is memoized, including an opaque-origin null.
 *
 * @returns {{ apiHost: string|null }}
 */
export function getApiHost() {
  return { apiHost: globalThis.sparkleApiHost ?? bundleOrigin() };
}

// A file: or data: URL has an opaque origin, which `URL` serializes as the
// string "null" — truthy, and rejected as a base by the URL constructor. Under
// a test runner the bundle is a file: URL, so returning it hands every client a
// base that throws `ERR_INVALID_URL` on the first request.
function bundleOrigin() {
  if (bundleApiHost !== undefined) {
    return bundleApiHost;
  }

  const { origin } = new URL(import.meta.url);

  bundleApiHost = origin === "null" ? null : origin;

  return bundleApiHost;
}
